/* istanbul ignore file */
import React from 'react';
import { Flex } from './layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledChipV2 = styled(Flex)`
  border: 1px solid ${getColor('pigeonPost')};
  border-radius: 1.7rem;
  padding: 0.4rem 0.8rem;
  width: fit-content;
  height: fit-content;
  background-color: ${getColor('white')};
`;
const ChipV2 = ({ children, style }) => (
  <StyledChipV2 style={style}>{children}</StyledChipV2>
);

export default ChipV2;
